export default __webpack_public_path__ + "static/ehv-shiny-black-f14a48a6076c69b5a2b57d56fa6e9430.webp";